import { IdentityProviderType } from 'models/identityProvider';
import { UserTypes } from 'models/user';

export default class UserDTO {
  userId: string;

  tenantId?: string;

  identityProviderType?: IdentityProviderType;

  providerUserId?: string;

  name: string;

  email: string;

  userType?: UserTypes;

  created?: string;

  lastLogin?: string;

  hasLicense: boolean;

  userLanguageCode?: string;

  roles?: string[];

  groups?: string[];

  userTimeZoneCode?: string;

  systemRoleIds?: number[];

  eventSubscriptionId?: string;

  eventSubscriptionExp?: Date;

  eventSubscriptionSync?: boolean;

  constructor() {
    this.userId = '';
    this.name = '';
    this.email = '';
    this.hasLicense = false;
  }
}
